<template>
  <section class="looking-for bg-primary position-relative">
    <BannerVector width="626" height="343" class="d-none d-lg-block bg-vector position-absolute opacity-50" />
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10">
          <h2>{{props.whatAreYouLookingFor.title}}</h2>
          <div v-html="props.whatAreYouLookingFor.description" ></div>
          <div class="d-flex">
            <Input
              v-model="searchValue"
              :shouldHaveSearchClear="true"
              :placeholder="props.whatAreYouLookingFor.input.placeholder"
              @onInputEnterClick="handleSearchClick"
            />
            <ButtonRed
              :text="props.whatAreYouLookingFor.button.text" 
              @click="handleSearchClick"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import Input from "@/components/common/Input";
import ButtonRed from "@/components/common/ButtonRed";
import BannerVector from "@/assets/icons/banner-vector";
import { ref } from "vue";

const searchValue = ref('');

const props = defineProps({
  whatAreYouLookingFor: {
    title: String,
    description: String,
    input: {
      placeholder: String,
    },
    button: {
      text: String,
      link: String
    }
  }
})

const handleSearchClick = () => {
  window.location.href = `${window.location.origin}/search-results?keywords=${searchValue.value}`
  searchValue.value = '';
}

</script>
